module.exports = __webpack_public_path__ + "__static/site-1747751661846/img/how-works-mobile--en.346f95bc.jpg";